import {Option} from "fp-ts/lib/Option"
import {delay} from "./tsutil"

export const standardTimeout = 40 * 1000 /* 40 seconds */

export const standardDelay = 1000 /* 1 second */

export async function pollWithTimeout<T>(
  action: () => Promise<Option<T>>,
  timeoutMs: number = standardTimeout,
  delayMs: number = standardDelay,
): Promise<T> {
  let cancelled = false
  const timeout = setTimeout(() => {
    cancelled = true
  }, timeoutMs)
  try {
    while (!cancelled) {
      const ret = await action()
      if (ret.isSome()) {
        return ret.value
      }
      await delay(delayMs)
    }
    throw new Error("Timed out")
  } finally {
    clearTimeout(timeout)
  }
}



// WEBPACK FOOTER //
// ./src/timeout.ts